// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__vB-hh","alertIcon":"ConfirmModal_alertIcon__ZF0e6"};